import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { createNormalizedMap, handleFetchError, pushApps } from 'action-utils';
import { setSearchInput } from 'actions/gallery';
import { searchDeveloperPreviewQuery } from '../../queries';

const STATE_PROP = 'searchDeveloperPreview';

export default new AsyncActionHandler({
  name: 'search_developer_preview',
  stateProp: STATE_PROP,
  defaultState: {
    [STATE_PROP]: {},
    searchPages: {},
    apps: {}
  },
  handler(developerName, developerProfileId) {
    return async (dispatch) => {
      dispatch(
        setSearchInput({
          developerName,
          developerProfileId,
          userSetInput: true
        })
      );

      if (!developerProfileId) {
        return;
      }

      try {
        const {
          data: { appSearchResults, clockSearchResults, tileSearchResults } = {}
        } = await apollo.query({
          query: searchDeveloperPreviewQuery,
          variables: {
            developerProfileId
          },
          fetchPolicy: 'no-cache'
        });

        return {
          developerProfileId,
          appSearchResults,
          clockSearchResults,
          tileSearchResults
        };
      } catch (error) {
        return handleFetchError(error);
      }
    };
  },

  reduce(
    state,
    {
      developerProfileId,
      appSearchResults,
      clockSearchResults,
      tileSearchResults
    }
  ) {
    if (!appSearchResults || !clockSearchResults || !tileSearchResults) {
      return state;
    }

    const allEntries = [
      ...appSearchResults.apps,
      ...clockSearchResults.apps,
      ...tileSearchResults.apps
    ];
    const entries = pushApps([], allEntries);

    return {
      [this.stateProp]: {
        [developerProfileId]: {
          entries
        }
      },
      apps: {
        ...state.apps,
        ...createNormalizedMap(allEntries, state.apps)
      }
    };
  }
});
